import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

// Create axios instance with base configuration
const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true, // CRITICAL: Send cookies with every request
});

// Request interceptor
api.interceptors.request.use(
    (config) => {
        if (process.env.NODE_ENV === 'development') {
            console.log(`API Request: ${config.method.toUpperCase()} ${config.url}`);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor (handle errors globally)
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Prevent refresh loop - don't retry refresh, verify, or login endpoints
        const isAuthEndpoint = originalRequest.url?.includes('/api/auth/refresh') ||
            originalRequest.url?.includes('/api/auth/verify') ||
            originalRequest.url?.includes('/api/auth/login');

        // If 401 and not already retried and not an auth endpoint, try to refresh token
        if (error.response?.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
            originalRequest._retry = true;

            try {
                // Call refresh endpoint
                const refreshResponse = await api.post('/api/auth/refresh');

                // Retry original request
                return api(originalRequest);
            } catch (refreshError) {
                // Refresh failed - redirect to login
                console.error('Token refresh failed:', refreshError);
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        // If it's an auth endpoint that failed, just reject
        if (error.response?.status === 401 && isAuthEndpoint) {
        }

        return Promise.reject(error);
    }
);

export default api;
